import React from "react"
import Scroll from "../Scroll/Scroll"
import './Instructions.scss'

const Instructions = (props) => {
    return (
        <div className="instructionsContainer">
            <Scroll>
                <div className="instructions" dangerouslySetInnerHTML={{ __html: props.body }}></div>
            </Scroll>
        </div>
    );
}

export default Instructions;